<template>
	<div class="modal modal--md" id="popup-pawn-review">
		<div class="modal-form">
			<div class="modal-form__title">Оставить отзыв</div>
			<form class="form order-call">
				<div class="form__inputs form__inputs--2">
					<div class="form__inputs-input">
						<div class="default-input">
							<label class="default-input__label" for="preview-name">Введите ваше имя</label>
							<div class="default-input__input" :class="{'default-input__input--error' : v$.formData.name.$errors.length}">
								<input v-model="formData.name" type="text" inputmode="text" id="preview-name" placeholder="Иванов Иван" tabindex="0">
							</div>
							<div v-if="v$.formData.name.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.name.$errors" :key="index">{{
										error.$message
									}}</span>
							</div>
						</div>
					</div>
					<div class="form__inputs-input">
						<div class="default-input">
							<label class="default-input__label" for="preview-mail">Введите ваш E-mail</label>
							<div class="default-input__input" :class="{'default-input__input--error' : v$.formData.email.$errors.length}">
								<input v-model="formData.email" type="email" inputmode="email" id="preview-mail" placeholder="mail@gmail.com" tabindex="0">
							</div>
							<div v-if="v$.formData.email.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.email.$errors" :key="index">{{
										error.$message
									}}</span>
							</div>
						</div>
					</div>
					<div class="form__inputs-input">
						<div class="default-input">
							<label class="default-input__label" for="preview-phone">Введите ваш телефон</label>
							<div class="default-input__input" :class="{'default-input__input--error' : v$.formData.phone.$errors.length}">
								<input v-model="formData.phone" type="tel" ref="inputPhone" placeholder="+7 (999) 549 34 95" id="preview-phone" inputmode="text" tabindex="0">
							</div>
							<div v-if="v$.formData.phone.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.phone.$errors" :key="index">{{
										error.$message
									}}</span>
							</div>
						</div>
					</div>
					<div class="form__inputs-input">
						<div class="default-input">
							<label class="default-input__label">Адрес ломбарда</label>
							<div class="default-input__input">
								<input v-if="pawnData" type="text" inputmode="text" :disabled="true" placeholder="Введите адрес" :value="`${pawnData.street}, ${pawnData.house}`" tabindex="0">
							</div>
						</div>
					</div>
					<div class="form__inputs-input form__inputs-input--2">
						<div class="default-input">
							<label class="default-input__label" for="preview-message">Напишите сообщение</label>
							<div class="default-input__input" :class="{'default-input__input--error' : v$.formData.message.$errors.length}">
								<textarea v-model="formData.message" placeholder="" id="preview-message" tabindex="0"></textarea>
							</div>
							<div v-if="v$.formData.message.$errors.length" class="default-input__error">
								<span v-for="(error, index) in v$.formData.message.$errors" :key="index">{{ error.$message }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="form__submit">
					<div class="form__submit-text">
						<div class="default-checkbox">
							<input hidden="" class="default-checkbox__input" id="checkbox-popup-pawn-review-advert-agreement" type="checkbox" name="advert-agreement" value="Y" required />
							<label class="default-checkbox__label" for="checkbox-popup-pawn-review-advert-agreement">
								<span>Я&nbsp;<a :href="documents['advertising-agreement']" target="_blank" >согласен на получение рекламы</a></span>
							</label>
						</div>
					</div>
					
					<div class="form__submit-btn">
						<button class="btn color shadow" tabindex="0" @click.prevent="sendForm" :disabled="loading">
							Отправить
						</button>
					</div>

					<div class="form__submit-text">
						<p>
							Нажимая кнопку «Отправить», вы даете информированное
							<a :href="documents['personal-data']" target="_blank">согласие на обработку персональных данных</a>
							в соответствии с <a :href="documents['policy']" target="_blank">Политикой обработки персональных данных потребителей</a>
						</p>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required, helpers, email, maxLength} from '@vuelidate/validators'
import Inputmask from "inputmask";
import Fetch from "@/utils/Fetch";
import objectToFormData from "@/utils/ObjectToFormData";
import {mapGetters, mapMutations} from "vuex";

const {withMessage} = helpers
export default {
	name: "PopupPawnReview",
	props: {
		pawnData: {
			type: [Object, null],
			required: true,
			default: () => {
			}
		}
	},
	setup() {
		return {
			v$: useVuelidate()
		}
	},
	data() {
		return {
			loading: false,
			userDataTrigger: null,
			formData: {
				name: '',
				email: '',
				message: '',
				phone: ''
			},
		}
	},
	validations() {
		return {
			formData: {
				name: {
					required: withMessage('Необходимо указать имя', required),
					maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
				},
				phone: {
					required: withMessage('Необходимо указать телефон', required),
					maxLength: withMessage('Максимальная длина поля 50 символов', maxLength(50)),
				},
				email: {
					email: withMessage('Неверный формат электронной почты', email),
					required: withMessage('Необходимо указать E-mail', required),
					maxLength: withMessage('Максимальная длина поля 100 символов', maxLength(100)),
				},
				message: {
					required: withMessage('Необходимо указать вопрос', required),
					maxLength: withMessage('Максимальная длина поля 250 символов', maxLength(250)),
				},
			}
		}
	},
	async mounted() {
		Inputmask('+7 (999) 999 99 99').mask(this.$refs.inputPhone)
		this.setInitialData();
	},
	computed: {
		...mapGetters({
			userData: 'user/getUserData',
			documents: 'getDocuments'
		})
	},
	methods: {
		setInitialData() {
			if (this.userData) {
				this.formData = {
					name: this.userData.name,
					email: this.userData.email,
					message: '',
					phone: this.userData.phone
				}
			} else {
				this.formData = {
					name: '',
					email: '',
					message: '',
					phone: ''
				}
				if (!this.userDataTrigger) {
					this.userDataTrigger = this.$watch('userData', (newValue) => {
						this.formData = {
							name: newValue.name,
							email: newValue.email,
							message: '',
							phone: newValue.phone
						}
						this.userDataTrigger();
					});
				}
			}
		},
		async sendForm() {
			this.loading = true
			const result = await this.v$.formData.$validate()
			if (!result) {
				this.loading = false
				return
			}

			let body = objectToFormData({
				fio: this.formData.name,
				email: this.formData.email,
				message: this.formData.message,
				phone: this.formData.phone,
				pawn_id: this.pawnData.id
			})

			let response = await Fetch('pawns/review/', {
				method: 'POST',
				body
			})
			if (response.success) {
				this.setSuccess({title: 'Отзыв отправлен!', message: response.message})
			} else {
				this.setSuccess({title: 'Что-то пошло не так!', message: response.message})
			}
			this.loading = false

			window.fancyboxConstructor.show([{src: "#popup-success", type: "inline"}], {
				Toolbar: false,
				dragToClose: false,
				Thumbs: false,
				closeButton: "top",
				mainClass: "fancybox-modal",
				on: {
					closing: () => {
						window.fancyboxConstructor.close()
					}
				}
			})

			if (response.success) {
				this.clearForm()
			}
		},
		clearForm() {
			this.setInitialData();
			this.v$.$reset()
		},
		...mapMutations({
			setSuccess: 'setPopupSuccessData'
		})
	}
}
</script>

<style scoped>

</style>
